import {
  getEnv,
  handleNetwork,
  ky,
  memoize,
  returnNetworkError,
  ValidationError,
} from "@solvari/utils";

type PhoneCountry = Solvari.Common.Enums.ActiveCountryEnum;

const getPhoneValidation = handleNetwork(
  memoize(async (phone: string, country?: PhoneCountry) => {
    const result = await returnNetworkError(() =>
      ky
        .get(`${getEnv().network.api}/v3/validations/phone`, {
          searchParams: (country
            ? { phone, country }
            : {
                phone,
              }) satisfies App.Http.Requests.Api.System.PhoneValidationRequest,
        })
        .json<undefined>(),
    )();
    if (!result) {
      return true;
    }
    if (result instanceof ValidationError) {
      return false;
    }
    return result;
  }),
);

export { getPhoneValidation };
export type { PhoneCountry };
